import React, { useContext } from "react";
import HeaderInner from "../../Components/HeaderInner";
import Textheader from "../../Components/Textheader";
import Clientinfo from "../../Components/Clientinfo";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import InStayRentalPriceBreakdown from "../../Components/InStayRentalPriceBreakdown";
import {
  formatRentalDateTime,
  formatRentalDuration,
  getRentalFrequency,
} from "../../utils/inStayRental";

function InStayRentalOrderPlaced() {
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const { metadata } = location.state || {};
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const booking = metadata?.booking;
  const bookingFrequency = getRentalFrequency(booking?.frequency);

  return (
    <div className={theme ? "food" : ""}>
      {theme ? <Title title={t("Order Details")} /> : <HeaderInner />}
      <main className="bg-white pad-top-0 back-white">
        <Textheader />
        <Clientinfo
          roomNumber={metadata?.res?.room_name}
          orderNumber={metadata?.res?.order_number}
          orderedAt={metadata?.res?.ordered_at}
        />

        <div className="full-heading grey-bg flex">
          <h2 className="blck co-header">{t("Order Details")}</h2>
        </div>

        <div className="full-div padd-div">
          <div className="booking-order-detail">
            {metadata?.item?.image && (
              <div className="img-pnl">
                <img src={metadata.item.image} alt={metadata.item.name} />
              </div>
            )}
            <div className="txt-pnl">
              <p>{metadata?.item?.name}</p>
            </div>
          </div>
        </div>

        {booking && bookingFrequency && (
          <>
            <div className="full-heading grey-bg flex">
              <h2 className="blck co-header">{t("Booking Details")}</h2>
            </div>
            <div className="check-list-container">
              <ul className="check-list v3">
                <li>
                  <p>{t("Payment Frequency")}</p>
                  <p>{t(bookingFrequency.label)}</p>
                </li>
                {bookingFrequency.durationBased ? (
                  <>
                    <li>
                      <p>
                        {t(
                          bookingFrequency.withStartTime
                            ? "Start Date & Time"
                            : "Start Date"
                        )}
                      </p>
                      <p>
                        {formatRentalDateTime(
                          booking.startDate,
                          booking.startTime
                        )}
                      </p>
                    </li>
                    <li>
                      <p>{t("Duration")}</p>
                      <p>
                        {formatRentalDuration(
                          t,
                          bookingFrequency,
                          booking.duration
                        )}
                      </p>
                    </li>
                    <li>
                      <p>
                        {t(
                          bookingFrequency.withStartTime
                            ? "End Date & Time"
                            : "End Date"
                        )}
                      </p>
                      <p>
                        {formatRentalDateTime(booking.endDate, booking.endTime)}
                      </p>
                    </li>
                  </>
                ) : (
                  <li>
                    <p>{t("Duration")}</p>
                    <p>{t("For your entire stay")}</p>
                  </li>
                )}
              </ul>
            </div>

            <div className="full-heading grey-bg flex">
              <h2 className="blck co-header">{t("Price Details")}</h2>
            </div>
            <div className="check-list-container">
              <InStayRentalPriceBreakdown
                quote={booking}
                currency={booking.currency}
              />
            </div>
          </>
        )}

        <div className="spacer-20"></div>
        <div className="full-div padd-div text-center">
          <Link className="reg-btn large" to={`/${room_uuid}/qr-code`}>
            {t("Back to Home")}
          </Link>
        </div>
      </main>
      {theme && <NewFooter />}
    </div>
  );
}

export default InStayRentalOrderPlaced;
